import React from 'react';
import { FiStar, FiCheck } from 'react-icons/fi';
import './Testimonials.css';

// Static placeholder testimonials — not tied to real orders/reviews.
// Swap for real customer quotes once available.
const REVIEWS = [
  { text: "Everything came packed really well and the noodles were fresh. Ordered a few different flavors and honestly liked all of them. Will order again.",                     name: 'Hira S.',   city: 'Karachi' },
  { text: "Finally found a place with a good variety of Korean products. The Samyang and drinks arrived exactly as shown. Delivery was also pretty quick.",                        name: 'Ahmed R.',  city: 'Lahore' },
  { text: "Got a few Korean skincare products this time and I'm really happy with them. Everything was packed nicely and the products arrived in perfect condition. Will definitely try more.", name: 'Mariam A.', city: 'Islamabad' },
  { text: "I'd been looking for these skincare products for a while and finally found them here. The products were sealed properly and delivery was faster than I expected.",     name: 'Danish K.', city: 'Rawalpindi' },
  { text: "Loved the selection. I got some ramen, Korean drinks and skincare products in the same order which was really convenient. Will definitely be shopping here again.",     name: 'Sana F.',   city: 'Multan' },
  { text: "Was a little unsure about ordering at first but everything turned out great. Good packaging, fresh products and delivery was on time.",                                 name: 'Usman M.',  city: 'Faisalabad' },
];

function Testimonials() {
  return (
    <section className="testi-section">
      <div className="testi-header">
        <span className="testi-tag"><FiStar size={11} /> Testimonials</span>
        <h2 className="testi-title">Loved by Customers Across Pakistan</h2>
        <p className="testi-subtitle">Real feedback from real customers</p>
      </div>

      <div className="testi-grid">
        {REVIEWS.map((r, i) => (
          <div key={i} className="testi-card">
            <span className="testi-quote">&ldquo;</span>
            <div className="testi-stars">
              {[1,2,3,4,5].map(s => <FiStar key={s} size={14} className="testi-star" />)}
            </div>
            <p className="testi-text">&ldquo;{r.text}&rdquo;</p>
            <div className="testi-footer">
              <span className="testi-avatar">{r.name[0]}</span>
              <div className="testi-footer-info">
                <span className="testi-name">{r.name}, {r.city}</span>
                <span className="testi-verified"><FiCheck size={11} /> Verified Buyer</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Testimonials;
